var _mask, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapPriceSelectedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h16.51L23 29l4.49-5H44a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h16.51L23 29l4.49-5H44a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Z",
    fill: "#20274D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.51 24 .743-.668-.297-.332h-.447v1ZM23 29l-.744.668.744.829.744-.829L23 29Zm4.49-5v-1h-.445l-.299.332.745.668ZM1 2a1 1 0 0 1 1-1v-2a3 3 0 0 0-3 3h2Zm0 20V2h-2v20h2Zm1 1a1 1 0 0 1-1-1h-2a3 3 0 0 0 3 3v-2Zm16.51 0H2v2h16.51v-2Zm5.234 5.332-4.49-5-1.489 1.336 4.491 5 1.488-1.336Zm3.003-5-4.491 5 1.488 1.336 4.49-5-1.488-1.336ZM44 23H27.49v2H44v-2Zm1-1a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3h-2Zm0-20v20h2V2h-2Zm-1-1a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3v2ZM2 1h42v-2H2v2Z",
    fill: "#fff",
    mask: "url(#a)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPriceSelectedIcon);
export default __webpack_public_path__ + "static/media/map-price-selected-icon.67900f33d6ea05789253a975f2a7bdbd.svg";
export { ForwardRef as ReactComponent };